'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this line will exclude the key being used
//const getObj = (el, specifiedKey) => Object.keys(el).filter(key => {
//return key !== specifiedKey;
var getObj = function getObj(el) {
  return (0, _keys2.default)(el).reduce(function (elObj, key) {
    return (0, _extends6.default)({}, elObj, (0, _defineProperty3.default)({}, key, el[key]));
  }, {});
};

var processArr = function processArr(arr) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  return arr.reduce(function (obj, el) {
    if (typeof el === 'string') {
      return (0, _extends6.default)({}, obj, (0, _defineProperty3.default)({}, el, (0, _extends6.default)({}, fn(el))));
    }

    return (0, _extends6.default)({}, obj, (0, _defineProperty3.default)({}, el[key], (0, _extends6.default)({}, getObj(el, key), fn(el))));
  }, {});
};

var arrayAsObj = function arrayAsObj(arr) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  if (!Array.isArray(arr)) {
    console.error('Invalid array', arr);
    throw new Error('Invalid array provided');
  }

  if (typeof rest[0] === 'function') {
    return processArr.apply(undefined, [arr, undefined].concat(rest));
  }

  return processArr.apply(undefined, [arr].concat(rest));
};

exports.default = arrayAsObj;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/arrayAsObj.js
// module id = 146
// module chunks = 0